import AppBar from '@/components/app-bar/AppBar.vue'
import AppBarSpace from '@/components/app-bar/AppBarSpace.vue'
import { getToken, setToken } from '@/local/user'

export default {
    name: 'Login',
    components: {
        AppBar,
        AppBarSpace,
    },
    data() {
        return {
            token: getToken(),
            redirect: this.$route.query.redirect
        }
    },
    methods: {
        setDebugToken() {
            this.token = process.env.VUE_APP_DEBUG_TOKEN
        },
        login() {
            if (!this.token || this.token.trim() === '') {
                this.$toast.fail('请填写 Token')
                return
            }
            setToken(this.token)
            this.$toast.success('Token 设置成功')
            if (this.redirect) {
                this.$router.replace(this.redirect)
            } else {
                this.$navBack()
            }
        },
        logout() {
            this.token = null
            setToken('')
            this.$toast.success('Token 清除成功')
        }
    }
}
